import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 24px;

  overflow-x: auto;
  overflow-y: visible;

  background-color: ${(props) => props.theme.colors?.greys?.lighter};
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ListViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  width: 100%;
`;

export const ListViewWrapper = styled.div`
  height: 590px;
  min-width: ${({ minWidth }) => minWidth}px;
`;

export const TotalRowContainer = styled.div`
  display: flex;
  align-items: center;
  min-width: ${({ minWidth }) => minWidth}px;
`;

export const TotalLabelCell = styled.div`
  padding: 0px 15px;
  color: ${({ theme }) => theme.colors.greys.dark};
  font: ${({ theme }) => theme.fonts.textMiddleBold};
  min-width: ${({ minWidth }) => minWidth}px;
  flex: 1;
`;

export const TotalCircleCell = styled.div`
  padding: 0px 15px;
  display: flex;
  justify-content: flex-start;
  min-width: ${({ minWidth }) => minWidth}px;
  flex: 2;
`;

export default {
  Container,
  ListViewContainer,
  ButtonContainer,
};
